(() => {
 const phone=window.matchMedia('(max-width:680px)');
 const info=document.querySelector('#product .pdp-info');
 if(!info)return;
 const anchor=info.querySelector('.option-label');
 const header=document.querySelector('.hero-header');
 if(!anchor)return;
 let preview=null,image=null,label=null,observer=null,frame=0;
 function sync(name){
  if(!preview)return;
  name=name||document.getElementById('colourName')?.textContent.trim();
  const src=window.ICONS_COLOURS?.[name];
  if(!src)return;
  image.src=src;image.alt=`${name} Original case`;label.textContent=name;
 }
 function offset(){
  frame=0;
  if(!preview)return;
  const box=header?.getBoundingClientRect();
  const top=box?Math.max(0,Math.min(box.height,box.bottom)):0;
  info.style.setProperty('--case-preview-top',`${Math.round(top)}px`);
 }
 function schedule(){if(!frame)frame=requestAnimationFrame(offset)}
 function colour(event){sync(event.detail.name)}
 function mount(){
  if(!phone.matches){
   if(!preview)return;
   preview.remove();preview=image=label=null;
   observer?.disconnect();observer=null;
   window.removeEventListener('scroll',schedule);window.removeEventListener('resize',schedule);
   document.removeEventListener('icons:colour',colour);
   if(frame)cancelAnimationFrame(frame);frame=0;
   info.style.removeProperty('--case-preview-top');
   return;
  }
  if(preview)return;
  preview=document.createElement('div');preview.className='mobile-case-preview';
  preview.setAttribute('role','region');preview.setAttribute('aria-label','Selected case preview');
  image=document.createElement('img');image.decoding='async';image.draggable=false;
  const copy=document.createElement('div'),eyebrow=document.createElement('small'),detail=document.createElement('small');
  eyebrow.textContent='YOUR SELECTED CASE';detail.textContent=window.ICONS_RANGE&&window.ICONS_RANGE!=='original'?window.ICONS_RANGES[window.ICONS_RANGE].label:'Original · 29 g';
  label=document.createElement('strong');label.setAttribute('aria-live','polite');
  copy.append(eyebrow,label,detail);preview.append(image,copy);anchor.before(preview);
  sync();offset();
  document.addEventListener('icons:colour',colour);
  window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule,{passive:true});
  if(header&&'ResizeObserver' in window){observer=new ResizeObserver(schedule);observer.observe(header)}
 }
 phone.addEventListener('change',mount);mount();
})();
